import { render, staticRenderFns } from "./extensions.vue?vue&type=template&id=52c6a8a3"
import script from "./extensions.vue?vue&type=script&lang=js"
export * from "./extensions.vue?vue&type=script&lang=js"
import style0 from "./extensions.vue?vue&type=style&index=0&id=52c6a8a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports